'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _GridItemCTA = require('../GridItemCTA');

var _GridItemCTA2 = _interopRequireDefault(_GridItemCTA);

var _BlockWrapper = require('./components/BlockWrapper');

var _BlockWrapper2 = _interopRequireDefault(_BlockWrapper);

var _Title = require('./components/Title');

var _Title2 = _interopRequireDefault(_Title);

var _GridWrapper = require('./components/GridWrapper');

var _GridWrapper2 = _interopRequireDefault(_GridWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# GridContainerCTA
A container that contains a collection of CTAs.
 */
var GridContainerCTA = function GridContainerCTA(_ref) {
  var _ref$padded = _ref.padded,
      padded = _ref$padded === undefined ? true : _ref$padded,
      _ref$collapse = _ref.collapse,
      collapse = _ref$collapse === undefined ? true : _ref$collapse,
      gridChildren = _ref.gridChildren,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? null : _ref$title;

  var gridChildrenParsed = JSON.parse(gridChildren);
  var gridChildrenTransformed = gridChildrenParsed.map(function (child, index) {
    return _extends({}, child, {
      id: index
    });
  });

  var gridEvenOdd = gridChildrenTransformed.length % 2 === 0 ? 'even' : 'odd';
  var superSizeItems = gridChildrenTransformed.length < 3;

  return _react2.default.createElement(
    _BlockWrapper2.default,
    {
      $padded: padded
    },
    title && _react2.default.createElement(
      _Title2.default,
      null,
      title
    ),
    _react2.default.createElement(
      _GridWrapper2.default,
      null,
      gridChildrenTransformed && gridChildrenTransformed.map(function (child) {
        return _react2.default.createElement(_GridItemCTA2.default, {
          key: child.id,
          imgSrc: child.Image,
          title: child.Title,
          subtitle: child.SubTitle,
          links: child.Links,
          buttonLabel: child.ButtonLabel,
          buttonUrl: child.Url,
          collapse: collapse,
          gridEvenOdd: gridEvenOdd,
          superSize: superSizeItems
        });
      })
    )
  );
};

GridContainerCTA.propTypes = {
  /** whether the grid has padding on desktop screen sizes */
  padded: _propTypes2.default.bool,
  /** whether the grid items should collapse on mobile */
  collapse: _propTypes2.default.bool,
  /** the grid children items */
  gridChildren: _propTypes2.default.string.isRequired,
  /** title for the grid section */
  title: _propTypes2.default.string
};

GridContainerCTA.displayName = 'GridContainerCTA';

exports.default = GridContainerCTA;
GridContainerCTA.__docgenInfo = {
  'description': '# GridContainerCTA\r\nA container that contains a collection of CTAs.',
  'methods': [],
  'displayName': 'GridContainerCTA',
  'props': {
    'padded': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'whether the grid has padding on desktop screen sizes'
    },
    'collapse': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'whether the grid items should collapse on mobile'
    },
    'title': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'title for the grid section'
    },
    'gridChildren': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'the grid children items'
    }
  }
};